<script lang="ts">
  import { onMount } from 'svelte';
  import { Link } from 'svelte-routing';
  import { api } from '../lib/api/client';
  import { t } from '../lib/i18n/index.ts';

  // Reset sets a new password through an emailed link, which works once, for
  // an hour (spec 001 FR-018). Phones stay signed in.
  let { token }: { token: string } = $props();

  let username = $state('');
  let password = $state('');
  let error = $state('');
  let loading = $state(true);
  let busy = $state(false);
  let done = $state(false);

  onMount(async () => {
    try {
      username = (await api.get<{ username: string }>(`/auth/password-reset/${encodeURIComponent(token)}`)).username;
    } catch (e: any) {
      error = e.message;
    } finally {
      loading = false;
    }
  });

  // forUser is authNewPasswordFor split around the username, which shows in bold.
  const forUser = t('authNewPasswordFor', { username: '\u0000' }).split('\u0000');

  async function save(e: SubmitEvent) {
    e.preventDefault();
    error = '';
    busy = true;
    try {
      await api.post(`/auth/password-reset/${encodeURIComponent(token)}`, { password });
      done = true;
    } catch (err: any) {
      error = err.message;
    } finally {
      busy = false;
    }
  }
</script>

<div class="flex items-center justify-center min-h-full flex-1 p-4">
  <div class="card p-8 w-full max-w-md">
    <h1 class="text-2xl font-bold mb-2 text-center" style="color: var(--theme-accent);">{t('authNewPasswordTitle')}</h1>
    {#if loading}
      <p class="text-sm text-text-muted">{t('authNewPasswordChecking')}</p>
    {:else if done}
      <p class="text-sm mb-6">{t('authNewPasswordDone')}</p>
      <Link to="/login" class="btn btn-primary w-full block text-center">{t('authSignIn')}</Link>
    {:else if !username}
      <p class="text-sm mb-6">{error}</p>
      <Link to="/forgot" class="btn btn-secondary w-full block text-center">{t('authNewPasswordAskAgain')}</Link>
    {:else}
      <p class="text-sm text-text-muted mb-6">{forUser[0]}<strong class="text-text">{username}</strong>{forUser[1]}</p>
      {#if error}
        <div class="mb-4 p-3 rounded text-sm" style="background-color: var(--theme-error); color: var(--theme-base);">{error}</div>
      {/if}
      <form class="flex flex-col gap-4" onsubmit={save}>
        <input type="text" class="hidden" autocomplete="username" value={username} readonly />
        <div>
          <label for="password" class="block text-sm font-medium mb-1">{t('authNewPassword')}</label>
          <input id="password" type="password" class="input w-full" bind:value={password} required minlength="8" maxlength="72" autocomplete="new-password" />
          <p class="text-xs text-text-muted mt-1">{t('authNewPasswordRule')}</p>
        </div>
        <button type="submit" class="btn btn-primary w-full" disabled={busy}>{t('authNewPasswordSave')}</button>
      </form>
    {/if}
  </div>
</div>
